import React from 'react';
import { connect } from 'react-redux';
import CustomIcon from '../common/CustomIcon';
import { I18n } from 'react-redux-i18n-lite';
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';
import { BoxButton, Selector, Button } from '@netexknowledge/smart-components';
import { Link } from 'react-router';
import * as drawerActions from '../../actions/drawerActions';
import { TASK_TYPE } from '../../types/task';
import UserImage from '../common/UserImage';

class SelectTaskTypePanel extends React.Component {
  static propTypes = {
    task: PropTypes.object.isRequired,
    drawerActions: PropTypes.any,
    totalStudents: PropTypes.any,
    onChangeTaskType: PropTypes.func.isRequired,
    changeRandomGroups: PropTypes.func.isRequired
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      showRandomUserInput: false,
      selectedGroupOption: 0,
      randomGroups: []
    };
  }

  closePanel = () => {
    const { drawerActions } = this.props;
    drawerActions.closeDrawerAndRemoveContent();
  };

  componentDidMount() {
    const { task } = this.props;
    if (task.hasOwnProperty('selectedGroup')) {
      this.generateInitialGroups();
    }
  }

  generateInitialGroups = () => {
    const { totalStudents } = this.props;
    const groupOptions = this.generateGroupOptions(totalStudents);
    const defaultGroupOption = groupOptions[0];

    this.setState({ selectedGroupOption: defaultGroupOption }, () => {
      this.generateRandomGroups();
    });
  };

  generateRandomGroups = () => {
    const { task } = this.props;
    let { selectedGroupOption } = this.state;
    const students = [...task.students];
    const totalStudents = this.props.totalStudents;

    if (!selectedGroupOption) {
      // If not group size provided, send the max
      const groupOptions = this.generateGroupOptions(totalStudents);
      selectedGroupOption = groupOptions[0];
    }

    const studentsPerGroup = Math.floor(totalStudents / selectedGroupOption);
    let groups = {};

    for (let i = 1; i <= selectedGroupOption; i++) {
      groups[i] = [];
      for (let j = 0; j < studentsPerGroup && students.length; j++) {
        const randomIndex = Math.floor(Math.random() * students.length);
        groups[i].push(students[randomIndex]);
        students.splice(randomIndex, 1);
      }
    }

    // If there are remaining students after dividing them into groups, add them to the existing groups
    let groupIndex = 1;
    if (groups[groupIndex]) {
      while (students.length) {
        groups[groupIndex].push(students.pop());
        groupIndex = (groupIndex % selectedGroupOption) + 1;
      }
    }

    this.changeRandomGroups(groups);
  };

  renderRandomGroups = randomGroups => {
    if (randomGroups) {
      return (
        <div className="assignments-panel">
          <div className="users-categories no-padding">
            {Object.entries(randomGroups).map(([groupId, students]) => (
              <div key={groupId} className="users-category">
                <div className="section-title-label">
                  {I18n.t('rightPanel.groups.group')} {groupId}
                </div>
                <div className="users-category-icons">
                  {students.map(student => (
                    <div key={student._id} className={`user-icon`}>
                      <UserImage picture={student.picture} />
                      <div className="user-name">
                        {student.name} {student.surname}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      );
    }
  };

  handleSelection = type => {
    if (type === TASK_TYPE.GROUP) {
      this.setState({ showRandomUserInput: true });
    } else {
      this.props.onChangeTaskType(type);
    }
  };

  changeRandomGroups = randomGroups => {
    this.setState({ randomGroups });
  };

  handleGroupOptionChange = (e, groupOptions) => {
    const value = parseInt(groupOptions[e], 10);
    this.setState({ selectedGroupOption: value }, () => {
      this.generateRandomGroups();
    });
  };

  confirmRandomUsers = () => {
    this.props.onChangeTaskType(TASK_TYPE.GROUP);
    this.props.changeRandomGroups(this.state.randomGroups);
  };

  renderHeader() {
    return (
      <div className="header">
        <Link className="close" onClick={this.closePanel.bind(this)}>
          <CustomIcon name="close-button" size={24} />
        </Link>
        <span>{I18n.t('rightPanel.selectIndividualOrGroup.newAssignment')}</span>
      </div>
    );
  }

  generateGroupOptions = totalStudents => {
    let options = [];
    for (let i = Math.floor(totalStudents / 2); i >= 2; i--) {
      options.push(i);
    }
    return options;
  };

  render() {
    if (this.state.showRandomUserInput) {
      const groupOptions = this.generateGroupOptions(this.props.totalStudents);
      return (
        <div className="right-panel-new panel-group-task-type">
          <div className="wrapper">
            <div className="content">
              {this.renderHeader()}
              <div className="heading1">
                <span>{I18n.t('rightPanel.selectIndividualOrGroup.totalGroups')}</span>
              </div>
              <div>
                <Selector
                  id="total-groups-task-filter"
                  elements={groupOptions}
                  onChange={e => this.handleGroupOptionChange(e, groupOptions)}
                />
              </div>
            </div>
            {this.renderRandomGroups(this.state.randomGroups)}
          </div>

          <div className="btn-container">
            <Button
              className={`primaryButton`}
              onClick={this.confirmRandomUsers}
              label={I18n.t('common.confirm')}
            ></Button>
          </div>
        </div>
      );
    }

    return (
      <div className="right-panel-new panel-select-task-type">
        <div className="content">
          {this.renderHeader()}
          <div className="heading0">
            <p>{I18n.t('rightPanel.selectIndividualOrGroup.paragraph1')}</p>
          </div>
          <div className="heading1">
            <span>{I18n.t('rightPanel.newBook.chooseType')}</span>
          </div>
          <div className="add-resource-panel-buttons">
            <div className="add-resource-panel-buttons__one-item">
              <BoxButton
                id="individual"
                label={I18n.t('rightPanel.selectIndividualOrGroup.individual')}
                icon="custom-icons-messenger-user-avatar"
                onClick={() => this.handleSelection(TASK_TYPE.INDIVIDUAL)}
              />
              <div className="info-container">
                <CustomIcon name="information-circle" size={18} />
                <p>{I18n.t('rightPanel.selectIndividualOrGroup.paragraph2')}</p>
              </div>
            </div>
            <div className="add-resource-panel-buttons__one-item">
              <BoxButton
                id="group"
                label={I18n.t('rightPanel.selectIndividualOrGroup.grupal')}
                icon="custom-icons-group-users-avatar"
                onClick={() => this.handleSelection(TASK_TYPE.GROUP)}
              />
              <div className="info-container">
                <CustomIcon name="information-circle" size={18} />
                <p>{I18n.t('rightPanel.selectIndividualOrGroup.paragraph3')}</p>
              </div>
            </div>
          </div>
          <div>
            <div></div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    i18n: state.i18n
  };
}

function mapDispatchToProps(dispatch) {
  return {
    drawerActions: bindActionCreators(drawerActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectTaskTypePanel);
